<template>
	<div class="w-full transition-all duration-300 ease-in-out">
		<div
			class="rounded-xl px-3 py-2"
			style="background-color: var(--ion-color-semilight)"
		>
			<div class="flex gap-3 overflow-x-auto pb-2">
				<PlantingInfoCard
					v-for="planting in selectedPlantings"
					:key="planting.id"
					:planting="planting"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from "vue";
	import { useDefaultPlantingsQuery } from "@/composables/useDefaultPlantingsQuery";
	import PlantingInfoCard from "@/components/feature/notes/PlantingInfoCard.vue";

	interface Props {
		plantingIds: number[];
	}

	const props = defineProps<Props>();

	const { plantings } = useDefaultPlantingsQuery();

	const selectedPlantings = computed(() => {
		if (!plantings.value) return [];
		return plantings.value.filter((planting) =>
			props.plantingIds.includes(planting.id),
		);
	});
</script>
